import Base from './Base';

class City extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'cities';
    }

    getAll( ) {
        return  fetch(this.getUrlEndpoint("retrieve/"),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }
    
}

export default City;